/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CurrencyEntity,
    CurrencyEntityFromJSON,
    CurrencyEntityFromJSONTyped,
    CurrencyEntityToJSON,
} from './CurrencyEntity';
import {
    PortfolioEntity,
    PortfolioEntityFromJSON,
    PortfolioEntityFromJSONTyped,
    PortfolioEntityToJSON,
} from './PortfolioEntity';
import {
    SymbolWithExchangeDto,
    SymbolWithExchangeDtoFromJSON,
    SymbolWithExchangeDtoFromJSONTyped,
    SymbolWithExchangeDtoToJSON,
} from './SymbolWithExchangeDto';
import {
    TradeTypeEnum,
    TradeTypeEnumFromJSON,
    TradeTypeEnumFromJSONTyped,
    TradeTypeEnumToJSON,
} from './TradeTypeEnum';

/**
 * 
 * @export
 * @interface TradeListDto
 */
export interface TradeListDto {
    /**
     * 
     * @type {TradeTypeEnum}
     * @memberof TradeListDto
     */
    type: TradeTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof TradeListDto
     */
    value: number;
    /**
     * 
     * @type {SymbolWithExchangeDto}
     * @memberof TradeListDto
     */
    symbol: SymbolWithExchangeDto;
    /**
     * 
     * @type {Date}
     * @memberof TradeListDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof TradeListDto
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof TradeListDto
     */
    unitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof TradeListDto
     */
    fees: number;
    /**
     * 
     * @type {string}
     * @memberof TradeListDto
     */
    note?: string | null;
    /**
     * 
     * @type {CurrencyEntity}
     * @memberof TradeListDto
     */
    currency: CurrencyEntity;
    /**
     * 
     * @type {string}
     * @memberof TradeListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TradeListDto
     */
    referenceId?: string | null;
    /**
     * 
     * @type {PortfolioEntity}
     * @memberof TradeListDto
     */
    portfolio: PortfolioEntity;
    /**
     * 
     * @type {string}
     * @memberof TradeListDto
     */
    brokerName?: string | null;
}

export function TradeListDtoFromJSON(json: any): TradeListDto {
    return TradeListDtoFromJSONTyped(json, false);
}

export function TradeListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TradeTypeEnumFromJSON(json['type']),
        'value': json['value'],
        'symbol': SymbolWithExchangeDtoFromJSON(json['symbol']),
        'date': (new Date(json['date'])),
        'amount': json['amount'],
        'unitPrice': json['unitPrice'],
        'fees': json['fees'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'currency': CurrencyEntityFromJSON(json['currency']),
        'id': json['id'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'portfolio': PortfolioEntityFromJSON(json['portfolio']),
        'brokerName': !exists(json, 'brokerName') ? undefined : json['brokerName'],
    };
}

export function TradeListDtoToJSON(value?: TradeListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TradeTypeEnumToJSON(value.type),
        'value': value.value,
        'symbol': SymbolWithExchangeDtoToJSON(value.symbol),
        'date': (value.date.toISOString()),
        'amount': value.amount,
        'unitPrice': value.unitPrice,
        'fees': value.fees,
        'note': value.note,
        'currency': CurrencyEntityToJSON(value.currency),
        'id': value.id,
        'referenceId': value.referenceId,
        'portfolio': PortfolioEntityToJSON(value.portfolio),
        'brokerName': value.brokerName,
    };
}

